module.exports = __webpack_public_path__ + "img/1449980564.6a0a42e7.jpg";